// frontend/src/components/ui/AlertMessage.jsx
import React from 'react';
import './alert-message.scss';

const AlertMessage = ({ type = 'info', message, onClose }) => {
    const types = {
        success: { icon: '✅', className: 'alert-success' },
        error: { icon: '❌', className: 'alert-error' },
        warning: { icon: '⚠️', className: 'alert-warning' },
        info: { icon: 'ℹ️', className: 'alert-info' }
    };

    const currentType = types[type] || types.info;

    return (
        <div className={`alert-message ${currentType.className}`}>
            <span className="alert-icon">{currentType.icon}</span>
            <span className="alert-text">{message}</span>
            {onClose && (
                <button className="alert-close" onClick={onClose}>×</button>
            )}
        </div>
    );
};

export default AlertMessage;
